import InputFieldUploadHint from './InputFieldUploadHint';
import InputFieldUploadLabel from './InputFieldUploadLabel';

const inputFieldUploadCompoundComponents = {
  Label: InputFieldUploadLabel,
  Hint: InputFieldUploadHint,
};

export default inputFieldUploadCompoundComponents;
